import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs'

class CustomSlide extends HTMLElement {
  constructor() {
    super();

    const swiperElems = this.querySelectorAll('.swiper');
    for (const el of swiperElems) {
      const swiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 600,
        parallax: true,
        noSwipingClass: 'no-swipe'
      });
    }

    const navBtns = this.querySelectorAll('.nav-btn');

    const goToSlide = (e) => {
      e.preventDefault();

      navBtns.forEach(btn => btn.classList.remove('active'));
      e.target.classList.add('active');

      const idx = Number(e.target.dataset.index);
      for (const el of swiperElems) {
        el.swiper.slideTo(idx);
      }
    }

    for (const btn of navBtns) {
      btn.addEventListener('click', goToSlide);
    }
  }
}

if (!customElements.get('custom-slide')) {
  customElements.define('custom-slide', CustomSlide)
}